import React from "react";
import { spring, useCurrentFrame, useVideoConfig } from "remotion";
import { WordTimestamp } from "../../types";

interface KineticCaptionsProps {
  subtitles: WordTimestamp[];
}

export const KineticCaptions: React.FC<KineticCaptionsProps> = ({
  subtitles,
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const currentMs = (frame / fps) * 1000;

  let activeIndex = subtitles.findIndex(
    (sub) => currentMs >= sub.startMs && currentMs <= sub.endMs,
  );

  if (activeIndex === -1) {
    const pastWords = subtitles.filter((sub) => sub.endMs <= currentMs);
    activeIndex = pastWords.length > 0 ? pastWords.length - 1 : 0;
  }

  const activeSub = subtitles[activeIndex];
  const wordStartFrame = (activeSub.startMs / 1000) * fps;
  const elapsed = Math.max(0, frame - wordStartFrame);

  // Snappy spring scale pop for each single word flash
  const scale = spring({
    frame: elapsed,
    fps,
    from: 0.85,
    to: 1.1,
    config: { damping: 9, stiffness: 180, mass: 0.3 },
  });

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        minHeight: "160px",
        margin: "30px 0",
        zIndex: 10,
      }}
    >
      <span
        style={{
          display: "inline-block",
          fontFamily: "'Anton', sans-serif",
          fontWeight: 900,
          fontSize: "64px", // massive single-word flash size!
          textTransform: "uppercase",
          letterSpacing: "1.5px",
          color: "#ffd166", // bright yellow
          background: "#ff007f", // hot pink block background
          padding: "10px 30px",
          transform: `scale(${scale}) skewX(-8deg)`,
          boxShadow: "6px 6px 0px #ffffff",
          textShadow: "2px 2px 0px #000000",
        }}
      >
        {activeSub.word}
      </span>
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
